export enum ArtworkDescriptionEnum {
  Commission = 'commission',
  Contact = 'contact',
  Delivery = 'delivery',
  DeliveryTime = 'deliveryTime',
  Location = 'location',
  Return = 'return',
}
